/**
 * Checks if current browser is supported for running the app
 *
 * !! This is run in the bootstrap, so no TypeScript or ES5+ syntax here
 */
module.exports = {
    canRunShowroom: function () {
        // check browser support; we need flexbox and es5 support //
        var testEl = document.createElement('div'),
            props = ['flexWrap', 'FlexWrap', 'WebkitFlexWrap', 'MozFlexWrap', 'msFlexWrap'],
            cssPrefixes = ['', '-webkit-', '-moz-', '-ms-'],
            supportsFlex = false,
            supportsEs5 = Function.prototype.hasOwnProperty('bind'),
            i;

        for(i = 0; i < props.length; i++) {
            if (testEl.style[props[i]] !== undefined) {
                supportsFlex = true;
                break;
            }
        }

        // extra check for browsers with wrong flexbox implementations (ex.: IE10) //
        if (supportsFlex) {
            supportsFlex = false;
            for (i = 0; i < cssPrefixes.length; i++) {
                testEl.style.display = cssPrefixes[i] + "flex";
                if (testEl.style.display === (cssPrefixes[i] + "flex")) {
                    supportsFlex = true;
                    break;
                }
            }
        }

        return supportsFlex && supportsEs5;
    }
};


//////////////////
// WEBPACK FOOTER
// ./browserSupport.js
// module id = 337
// module chunks = 1 2